
// import React, { useState, useEffect, useRef } from 'react';
// import './dashboardfile.css';
// import Sidebar from '../Temp/Sidebar/Sidebar';
// import AnalyticsTab from '../Manager/NewDashboard/components/AnalyticsTab';
// import axios from 'axios';
// import { useNavigate, useLocation } from 'react-router-dom';
// import {
//   FaSearch,
//   FaBell,
//   FaEnvelope,
//   FaPlus,
//   FaChevronUp,
//   FaUserCircle,
//   FaEllipsisH,
//   FaLock,
//   FaChartBar,
//   FaChartPie,
//   FaCalendarAlt,
//   FaChevronDown,
//   FaUsers,
//   FaTrophy,
//   FaCheckCircle,
//   FaClock,
//   FaCalendar,
//   FaMicrophone,
//   FaCode,
//   FaNetworkWired,
//   FaArrowUp,
//   FaArrowDown,
//   FaBook,
// } from 'react-icons/fa';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { useOutletContext, Navigate } from "react-router-dom";

// export const Dashboard = () => {
//   const [isReady, setIsReady] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Start collapsed
//   const [isSidebarHovered, setIsSidebarHovered] = useState(false);
//   const [userName, setUserName] = useState('');
//   const [userRole, setUserRole] = useState(null);
//   const [fromDate, setFromDate] = useState(null);
//   const [toDate, setToDate] = useState(null);
//   const [departments, setDepartments] = useState([]);
//   const [selectedDepartment, setSelectedDepartment] = useState("");
//   const [deptLoading, setDeptLoading] = useState(false);
//   const [deptError, setDeptError] = useState(null);
//   const [managerDeptGuid, setManagerDeptGuid] = useState(null);
//   const [isManager, setIsManager] = useState(false);
//   const location = useLocation();
//   const dashboardFlag = sessionStorage.getItem("user_role");
//   const { permissionSet, permissionsLoading } = useOutletContext();


//   const fetchDepartments = async () => {
//     try {
//       setDeptLoading(true);
//       setDeptError(null);

//       const res = await axios.get('/coordinators/departments-list/', {
//         withCredentials: true
//       });

//       console.log(res, "resultt")

//       if (!res.data?.success) {
//         throw new Error(res.data.error || 'Failed to fetch departments');
//       }

//       const deptData = res.data?.data?.map((dept) => ({
//         id: dept.DepartmentGUID,
//         name: dept.Name,
//         guid: dept.DepartmentGUID, // ✅ CORRECT
//       }));

//       setDepartments(deptData);
//     } catch (err) {
//       console.error('Failed to fetch departments:', err);
//       const errorMsg = err.response?.data?.error || err.message || 'Failed to load departments. Please try again.';
//       setDeptError(errorMsg);
//       if (err.response?.status === 401) {
//         // Handle unauthorized: perhaps redirect to login
//         console.warn('Unauthorized - Redirecting to login...');
//         // navigate('/login'); // Uncomment if you have a login route
//       }
//     } finally {
//       setDeptLoading(false);
//     }
//   };

//   const navigate = useNavigate();
//   const contentRef = useRef(null);

//   // Helper to get the correct base path based on role
//   const getBasePath = () => {
//     if (userRole === '8') return '/managers/dashboard';
//     if (userRole === '9') return '/hr/dashboard';
//     console.warn('Unknown or missing role:', userRole);
//     return '/dashboard'; // fallback
//   };

//   console.log("Base Path:", getBasePath());

//   // Role-based navigation functions
//   const navigateToUpcomingExams = () => navigate(`${getBasePath()}/upcomingexams`);
//   console.log("Upcoming Exams Path:", `${getBasePath()}/upcomingexams`);
//   const navigateToCompletedExams = () => navigate(`${getBasePath()}/completedexams`);
//   const navigateToLeaderboards = () => navigate(`${getBasePath()}/leaderboards`);

//   // useEffect(() => {
//   //   let isMounted = true;

//   //   const fetchUserData = async () => {
//   //     try {
//   //       const response = await fetch('/api/payload/', {
//   //         credentials: 'include',
//   //       });

//   //       if (!response.ok) throw new Error('Failed to fetch user data');

//   //       const data = await response.json();

//   //       if (isMounted && data?.payload) {
//   //         const fullName = `${data.payload.first_name || ''} ${data.payload.last_name || ''}`.trim();
//   //         setUserName(fullName || 'User');

//   //         const role = data.payload.role_id?.toString();
//   //         if (role) {
//   //           setUserRole(role);
//   //           sessionStorage.setItem('user_role', role);
//   //         }

//   //       }

//   //       // fetch departments
//   //       await fetchDepartments();

//   //     } catch (error) {
//   //       console.error('Error fetching user data:', error);
//   //       setUserName('User'); // Fallback
//   //     } finally {
//   //       if (isMounted) {
//   //         setIsReady(true);
//   //       }
//   //     }
//   //   };

//   //   fetchUserData();

//   //   return () => {
//   //     isMounted = false;
//   //   };
//   // }, []);

//   useEffect(() => {
//     let isMounted = true;

//     const fetchUserData = async () => {
//       try {
//         const response = await fetch('/sso/payload/', {
//           credentials: 'include',
//         });

//         if (!response.ok) throw new Error('Failed to fetch user data');

//         const data = await response.json();

//         if (isMounted && data?.payload) {
//           const fullName =
//             `${data.payload.first_name || ''} ${data.payload.last_name || ''}`.trim();
//           setUserName(fullName || 'User');

//           // 🔥 FINAL ROLE DECISION
//           if (dashboardFlag) {
//             setUserRole(dashboardFlag.toString());
//             sessionStorage.setItem('user_role', dashboardFlag.toString());
//           }
//           // else {
//           //   const role = data.payload.role_id?.toString();
//           //   if (role) {
//           //     setUserRole(role);
//           //     sessionStorage.setItem('user_role', role);
//           //   }
//           // }
//         }

//         await fetchDepartments();
//       } catch (error) {
//         console.error('Error fetching user data:', error);
//         setUserName('User');
//       } finally {
//         if (isMounted) setIsReady(true);
//       }
//     };

//     fetchUserData();

//     return () => {
//       isMounted = false;
//     };
//   }, [dashboardFlag]);


//   useEffect(() => {
//     console.log('Dashboard flag:', dashboardFlag);
//     console.log('Effective userRole:', userRole);
//   }, [dashboardFlag, userRole]);

//   const handleToggleSidebar = () => setIsSidebarOpen(prev => !prev);
//   const handleSidebarMouseEnter = () => setIsSidebarHovered(true);
//   const handleSidebarMouseLeave = () => setIsSidebarHovered(false);

//   const clearDates = () => {
//     setFromDate(null);
//     setToDate(null);
//   };

//   const courseCards = [
//     {
//       id: 1,
//       title: 'Upcoming Assessments',
//       status: 'active',
//       icon: <FaCode className="course-icon" />,
//       onClick: navigateToUpcomingExams,
//       image: '/images/totalexamsyes.png',
//       description: 'Access all scheduled exams in one place and stay organized.',
//     },
//     {
//       id: 2,
//       title: 'Completed Assessments',
//       status: 'finished',
//       icon: <FaBook className="course-icon" />,
//       onClick: navigateToCompletedExams,
//       image: '/images/completedexamsyes.png',
//       description: 'Access past exam results with detailed scores and performance breakdowns.',
//     },
//     {
//       id: 3,
//       title: 'Leader Boards',
//       status: 'active',
//       icon: <FaNetworkWired className="course-icon" />,
//       onClick: navigateToLeaderboards,
//       image: '/images/image (4).jpg',
//       description: 'Check performance rankings among peers based on exam results.',
//     },
//   ];

//   // Loading overlay styles
//   const loadingOverlayStyle = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: 'rgba(255, 255, 255, 0.95)',
//     backdropFilter: 'blur(5px)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 9999,
//     opacity: isReady ? 0 : 1,
//     visibility: isReady ? 'hidden' : 'visible',
//     transition: 'opacity 0.5s ease, visibility 0.5s ease',
//   };

//   const gifContainerStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     textAlign: 'center',
//   };

//   const gifStyle = {
//     width: '400px',
//     height: '400px',
//     objectFit: 'contain',
//     filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1))',
//   };

//   // Final sidebar state: open if permanently toggled OR hovered
//   const isSidebarExpanded = isSidebarOpen || isSidebarHovered;

//   if (permissionsLoading) return <div>Loading...</div>;

//   const isManagerRoute = location.pathname.startsWith("/managers/dashboard");
//   const isHrRoute = location.pathname.startsWith("/hr/dashboard");

//   const canAccessDashboard =
//     (isManagerRoute && permissionSet.has(8)) ||
//     (isHrRoute && permissionSet.has(4));

//   if (!canAccessDashboard) {
//     return <Navigate to="/error" replace />;
//   }

//   return (
//     <div className="dashboard-container">
//       {/* Loading Overlay */}
//       {!isReady && (
//         <div style={loadingOverlayStyle}>
//           <div style={gifContainerStyle}>
//             <div style={{ position: 'relative' }}>
//               <img
//                 src="/images/breath1.gif"
//                 alt="Loading..."
//                 style={gifStyle}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Sidebar Wrapper with Fixed Width + Hover Control */}
//       {/* <div
//         className="w-[95px] flex-shrink-0"
//         onMouseEnter={handleSidebarMouseEnter}
//         onMouseLeave={handleSidebarMouseLeave}
//       >
//         <Sidebar
//           userRole={userRole}
//           isOpen={isSidebarExpanded}
//           toggleSidebar={handleToggleSidebar}
//           onMouseEnter={handleSidebarMouseEnter}
//           onMouseLeave={handleSidebarMouseLeave}
//         />
//       </div> */}

//       <div
//         ref={contentRef}
//         className={`main-content ${!isSidebarExpanded ? 'expanded' : ''} ${!isReady ? 'content-loading' : ''}`}
//         style={{
//           opacity: isReady ? 1 : 0.7,
//           transition: 'opacity 0.3s ease',
//         }}
//       >
//         {/* Welcome Section */}
//         <section className="emp-welcome-card">
//           <div className="emp-welcome-illustration"></div>
//           <div className="emp-welcome-content">
//             <div className="emp-welcome-text">
//               <h1>Hello {userName || <span className="loading-text">Loading...</span>}, Welcome Back!</h1>
//               <p>Skillora is an all-in-one assessment tool that automates the entire process of tracking learning progress, measuring skills, and conducting assessments across all domains.</p>
//             </div>
//           </div>
//         </section>

//         <section className="department-section">
//           <div className="department-wrapper">
//             <select
//               className="department-dropdown"
//               value={selectedDepartment}
//               onChange={(e) => setSelectedDepartment(e.target.value)}
//               disabled={deptLoading || !!deptError}
//             >
//               <option value="">
//                 {deptLoading ? 'Loading departments...' : deptError ? 'Error loading' : 'Select Department'}
//               </option>

//               {departments.map((dept) => (
//                 <option key={dept.guid} value={dept.guid}>
//                   {dept.name}
//                 </option>
//               ))}
//             </select>
//             {deptError && (
//               <button className="retry-btn" onClick={fetchDepartments} style={{ marginLeft: '10px' }}>
//                 Retry
//               </button>
//             )}
//           </div>

//           {deptError && (
//             <p style={{ color: 'red', fontSize: '13px', textAlign: 'right' }}>
//               {deptError}
//             </p>
//           )}
//         </section>

//         <div className="dashboard-layout">
//           {/* Left Column - Analytics */}
//           <div className="analytics-column">
//             <section className="analytics-header-section">
//               <div
//                 className="section-header"
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   width: '100%',
//                 }}
//               >
//                 <h2
//                   style={{
//                     margin: 0,
//                     fontSize: '20px',
//                     fontWeight: 600,
//                   }}
//                 >
//                   Performance Analytics
//                 </h2>

//                 <div
//                   className="analytics-controls"
//                   style={{
//                     marginLeft: 'auto',
//                   }}
//                 >
//                   <div
//                     className="date-inputs-row"
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '12px',
//                     }}
//                   >
//                     {/* FROM DATE */}
//                     <div className="date-input-group">
//                       <label className="date-label">From Date</label>
//                       <DatePicker
//                         selected={fromDate}
//                         onChange={(date) => {
//                           setFromDate(date);
//                           if (toDate && date > toDate) setToDate(null);
//                         }}
//                         selectsStart
//                         startDate={fromDate}
//                         endDate={toDate}
//                         maxDate={toDate || new Date()}
//                         dateFormat="dd MMM yyyy"
//                         placeholderText="Start date"
//                         className="date-input"
//                         popperPlacement="bottom-start"
//                         showMonthDropdown
//                         showYearDropdown
//                         dropdownMode="select"
//                         yearDropdownItemNumber={8}
//                         scrollableYearDropdown
//                         customInput={
//                           <div className="custom-date-input">
//                             <FaCalendarAlt className="calendar-icon" />
//                             <span className="date-text">
//                               {fromDate
//                                 ? fromDate.toLocaleDateString('en-GB', {
//                                   day: '2-digit',
//                                   month: 'short',
//                                   year: 'numeric',
//                                 })
//                                 : 'Start date'}
//                             </span>
//                             {fromDate && (
//                               <button
//                                 type="button"
//                                 className="clear-individual-btn"
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setFromDate(null);
//                                 }}
//                               >
//                                 ×
//                               </button>
//                             )}
//                           </div>
//                         }
//                       />
//                     </div>

//                     {/* TO DATE */}
//                     <div className="date-input-group">
//                       <label className="date-label">To Date</label>
//                       <DatePicker
//                         selected={toDate}
//                         onChange={(date) => setToDate(date)}
//                         selectsEnd
//                         startDate={fromDate}
//                         endDate={toDate}
//                         minDate={fromDate}
//                         maxDate={new Date()}
//                         dateFormat="dd MMM yyyy"
//                         placeholderText="End date"
//                         className="date-input"
//                         popperPlacement="bottom-end"
//                         showMonthDropdown
//                         showYearDropdown
//                         dropdownMode="select"
//                         yearDropdownItemNumber={8}
//                         scrollableYearDropdown
//                         customInput={
//                           <div className="custom-date-input">
//                             <FaCalendarAlt className="calendar-icon" />
//                             <span className="date-text">
//                               {toDate
//                                 ? toDate.toLocaleDateString('en-GB', {
//                                   day: '2-digit',
//                                   month: 'short',
//                                   year: 'numeric',
//                                 })
//                                 : 'End date'}
//                             </span>
//                             {toDate && (
//                               <button
//                                 type="button"
//                                 className="clear-individual-btn"
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setToDate(null);
//                                 }}
//                               >
//                                 ×
//                               </button>
//                             )}
//                           </div>
//                         }
//                       />
//                     </div>

//                     {/* CLEAR BUTTON */}
//                     {(fromDate || toDate) && (
//                       <button
//                         className="global-clear-btn"
//                         onClick={clearDates}
//                         style={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '6px',
//                           marginTop: '22px',
//                         }}
//                       >
//                         <svg
//                           width="14"
//                           height="14"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="currentColor"
//                           strokeWidth="2.5"
//                         >
//                           <path d="M18 6L6 18M6 6l12 12" />
//                         </svg>
//                         Clear
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <AnalyticsTab fromDate={fromDate} toDate={toDate} departmentguid={selectedDepartment} />
//             </section>
//           </div>

//           {/* Right Column - Quick Access */}
//           <div className="quick-access-column">
//             <section className="quick-access-section">
//               <div className="section-header">
//                 <h2>Quick Access</h2>
//               </div>
//               <div className="quick-access-cards">
//                 {courseCards.map((card) => (
//                   <div
//                     key={card.id}
//                     className={`quick-access-card ${card.status} ${!isReady ? 'card-loading' : ''}`}
//                     onClick={isReady ? card.onClick : undefined}
//                     style={{
//                       cursor: isReady ? 'pointer' : 'default',
//                       pointerEvents: isReady ? 'auto' : 'none',
//                     }}
//                   >
//                     <div className={`status-badge ${card.status}`}>
//                       {card.status.charAt(0).toUpperCase() + card.status.slice(1)}
//                     </div>
//                     <FaEllipsisH className="menu-icon" />

//                     <div className="card-content-wrapper">
//                       <div className="quick-access-image-container">
//                         <img
//                           src={card.image}
//                           alt={card.title}
//                           className="quick-access-image"
//                           onError={(e) => {
//                             e.target.style.display = 'none';
//                             const iconWrapper = document.createElement('div');
//                             iconWrapper.className = 'quick-access-icon-wrapper';
//                             iconWrapper.innerHTML = card.icon;
//                             e.target.parentElement.appendChild(iconWrapper);
//                           }}
//                         />
//                       </div>

//                       <div className="card-text-content">
//                         <div className="text-content-wrapper">
//                           <h3>{card.title}</h3>
//                           <p className="quick-access-description">{card.description}</p>
//                         </div>
//                         <div className="quick-access-footer">
//                           <span className="view-details">View Details →</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </section>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

import React, { useState, useEffect, useRef } from 'react';
import './dashboardfile.css';
import AnalyticsTab from '../Manager/NewDashboard/components/AnalyticsTab';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaCode,
  FaNetworkWired,
  FaBook,
  FaCalendarAlt,
  FaEllipsisH,
} from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useOutletContext, Navigate } from "react-router-dom";

export const Dashboard = () => {
  const [isReady, setIsReady] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [deptLoading, setDeptLoading] = useState(false);
  const [deptError, setDeptError] = useState(null);
  const [managerDeptGuid, setManagerDeptGuid] = useState(null); // only for managers
  const location = useLocation();
  const dashboardFlag = sessionStorage.getItem("user_role");
  const { permissionSet, permissionsLoading } = useOutletContext();

  // Helper: get full user data from SSO session
  const getSSOUserData = () => {
    try {
      const ssoUserStr = sessionStorage.getItem('sso_user');
      if (ssoUserStr) {
        const ssoUser = JSON.parse(ssoUserStr);
        return ssoUser.user || null;
      }
    } catch (err) {
      console.error('Failed to parse sso_user', err);
    }
    return null;
  };

  const fetchDepartments = async () => {
    try {
      setDeptLoading(true);
      setDeptError(null);

      const res = await axios.get('/coordinators/departments-list/', {
        withCredentials: true
      });

      if (!res.data?.success) {
        throw new Error(res.data.error || 'Failed to fetch departments');
      }

      let deptData = res.data?.data?.map((dept) => ({
        id: dept.DepartmentGUID,
        name: dept.Name,
        guid: dept.DepartmentGUID,
      }));

      // 🔒 ONLY for managers: ensure his department exists and preselect it
      const isManagerRoute = location.pathname.startsWith("/managers/dashboard");
      const isManager = userRole === '8' && isManagerRoute;

      if (isManager && managerDeptGuid) {
        const existing = deptData.find(d => d.guid === managerDeptGuid);
        if (!existing) {
          const ssoUser = getSSOUserData();
          const deptName = ssoUser?.departmentName || 'Your Department';
          console.log(`Adding missing department: ${deptName} (${managerDeptGuid})`);
          deptData = [
            { guid: managerDeptGuid, name: deptName, id: managerDeptGuid },
            ...deptData
          ];
        }
        // Preselect the manager's department
        setSelectedDepartment(managerDeptGuid);
      }

      setDepartments(deptData);
    } catch (err) {
      console.error('Failed to fetch departments:', err);
      const errorMsg = err.response?.data?.error || err.message || 'Failed to load departments.';
      setDeptError(errorMsg);
    } finally {
      setDeptLoading(false);
    }
  };

  const navigate = useNavigate();
  const contentRef = useRef(null);

  const getBasePath = () => {
    if (userRole === '8') return '/managers/dashboard';
    if (userRole === '9') return '/hr/dashboard';
    return '/dashboard';
  };

  const navigateToUpcomingExams = () => navigate(`${getBasePath()}/upcomingexams`);
  const navigateToCompletedExams = () => navigate(`${getBasePath()}/completedexams`);
  const navigateToLeaderboards = () => navigate(`${getBasePath()}/leaderboards`);

  // Load user data and set manager info if needed
  useEffect(() => {
    let isMounted = true;

    const fetchUserData = async () => {
      try {
        const response = await axios.get('/sso/payload/', { withCredentials: true });
        const data = response.data;

        if (isMounted && data?.payload) {
          const fullName = `${data.payload.first_name || ''} ${data.payload.last_name || ''}`.trim();
          setUserName(fullName || 'User');

          if (dashboardFlag) {
            const role = dashboardFlag.toString();
            setUserRole(role);
            sessionStorage.setItem('user_role', role);

            // Only if role is 8 (potential manager) we fetch the department GUID from SSO
            if (role === '8') {
              const ssoUser = getSSOUserData();
              if (ssoUser?.departmentUid) {
                setManagerDeptGuid(ssoUser.departmentUid);
                // Do NOT set selectedDepartment here – fetchDepartments will do it
              } else {
                console.warn('Manager role but no departmentUid in SSO data');
              }
            }
          }
        }
        await fetchDepartments();
      } catch (error) {
        console.error('Error fetching user data:', error);
        setUserName('User');
      } finally {
        if (isMounted) setIsReady(true);
      }
    };

    fetchUserData();
    return () => { isMounted = false; };
  }, [dashboardFlag]);

  // Determine if this user is truly a manager (role 8 and on manager route)
  const isManagerRoute = location.pathname.startsWith("/managers/dashboard");
  const isManager = userRole === '8' && isManagerRoute;
  const isHrRoute = location.pathname.startsWith("/hr/dashboard");

  const handleToggleSidebar = () => setIsSidebarOpen(prev => !prev);
  const handleSidebarMouseEnter = () => setIsSidebarHovered(true);
  const handleSidebarMouseLeave = () => setIsSidebarHovered(false);
  const clearDates = () => { setFromDate(null); setToDate(null); };

  const courseCards = [
    {
      id: 1,
      title: 'Upcoming Assessments',
      status: 'active',
      icon: <FaCode className="course-icon" />,
      onClick: navigateToUpcomingExams,
      image: '/images/totalexamsyes.png',
      description: 'Access all scheduled exams in one place and stay organized.',
    },
    {
      id: 2,
      title: 'Completed Assessments',
      status: 'finished',
      icon: <FaBook className="course-icon" />,
      onClick: navigateToCompletedExams,
      image: '/images/completedexamsyes.png',
      description: 'Access past exam results with detailed scores and performance breakdowns.',
    },
    {
      id: 3,
      title: 'Leader Boards',
      status: 'active',
      icon: <FaNetworkWired className="course-icon" />,
      onClick: navigateToLeaderboards,
      image: '/images/image (4).jpg',
      description: 'Check performance rankings among peers based on exam results.',
    },
  ];

  const loadingOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(5px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    opacity: isReady ? 0 : 1,
    visibility: isReady ? 'hidden' : 'visible',
    transition: 'opacity 0.5s ease, visibility 0.5s ease',
  };

  const gifStyle = {
    width: '400px',
    height: '400px',
    objectFit: 'contain',
    filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1))',
  };

  const isSidebarExpanded = isSidebarOpen || isSidebarHovered;

  if (permissionsLoading) return <div>Loading...</div>;

  const canAccessDashboard =
    (isManagerRoute && permissionSet.has(8)) ||
    (isHrRoute && permissionSet.has(4));

  if (!canAccessDashboard) {
    return <Navigate to="/error" replace />;
  }

  return (
    <div className="dashboard-container">
      {!isReady && (
        <div style={loadingOverlayStyle}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img src="/images/breath1.gif" alt="Loading..." style={gifStyle} />
          </div>
        </div>
      )}

      <div
        ref={contentRef}
        className={`main-content ${!isSidebarExpanded ? 'expanded' : ''} ${!isReady ? 'content-loading' : ''}`}
        style={{ opacity: isReady ? 1 : 0.7, transition: 'opacity 0.3s ease' }}
      >
        <section className="emp-welcome-card">
          <div className="emp-welcome-illustration"></div>
          <div className="emp-welcome-content">
            <div className="emp-welcome-text">
              <h1>Hello {userName || 'User'}, Welcome Back!</h1>
              <p>Skillora is an all-in-one assessment tool that automates the entire process of tracking learning progress, measuring skills, and conducting assessments across all domains.</p>
            </div>
          </div>
        </section>

        <section className="department-section">
          <div className="department-wrapper">
            <select
              className="department-dropdown"
              value={selectedDepartment}
              onChange={(e) => setSelectedDepartment(e.target.value)}
              disabled={deptLoading || !!deptError || isManager}
            >
              {/* For managers the placeholder is hidden because a department is always selected */}
              {!isManager && (
                <option value="">
                  {deptLoading ? 'Loading departments...' : deptError ? 'Error loading' : 'Select Department'}
                </option>
              )}
              {departments.map((dept) => (
                <option key={dept.guid} value={dept.guid}>
                  {dept.name}
                </option>
              ))}
            </select>
            {deptError && !isManager && (
              <button className="retry-btn" onClick={fetchDepartments} style={{ marginLeft: '10px' }}>
                Retry
              </button>
            )}
          </div>
          {deptError && <p style={{ color: 'red', fontSize: '13px', textAlign: 'right' }}>{deptError}</p>}
        </section>

        <div className="dashboard-layout">
          <div className="analytics-column">
            <section className="analytics-header-section">
              <div className="section-header" style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600 }}>Performance Analytics</h2>
                <div className="analytics-controls" style={{ marginLeft: 'auto' }}>
                  <div className="date-inputs-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div className="date-input-group">
                      <label className="date-label">From Date</label>
                      <DatePicker
                        selected={fromDate}
                        onChange={(date) => { setFromDate(date); if (toDate && date > toDate) setToDate(null); }}
                        selectsStart
                        startDate={fromDate}
                        endDate={toDate}
                        maxDate={toDate || new Date()}
                        dateFormat="dd MMM yyyy"
                        placeholderText="Start date"
                        className="date-input"
                        popperPlacement="bottom-start"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        customInput={
                          <div className="custom-date-input">
                            <FaCalendarAlt className="calendar-icon" />
                            <span className="date-text">
                              {fromDate ? fromDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : 'Start date'}
                            </span>
                            {fromDate && (
                              <button type="button" className="clear-individual-btn" onClick={(e) => { e.stopPropagation(); setFromDate(null); }}>×</button>
                            )}
                          </div>
                        }
                      />
                    </div>
                    <div className="date-input-group">
                      <label className="date-label">To Date</label>
                      <DatePicker
                        selected={toDate}
                        onChange={(date) => setToDate(date)}
                        selectsEnd
                        startDate={fromDate}
                        endDate={toDate}
                        minDate={fromDate}
                        maxDate={new Date()}
                        dateFormat="dd MMM yyyy"
                        placeholderText="End date"
                        className="date-input"
                        popperPlacement="bottom-end"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        customInput={
                          <div className="custom-date-input">
                            <FaCalendarAlt className="calendar-icon" />
                            <span className="date-text">
                              {toDate ? toDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : 'End date'}
                            </span>
                            {toDate && (
                              <button type="button" className="clear-individual-btn" onClick={(e) => { e.stopPropagation(); setToDate(null); }}>×</button>
                            )}
                          </div>
                        }
                      />
                    </div>
                    {(fromDate || toDate) && (
                      <button className="global-clear-btn" onClick={clearDates} style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '22px' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path d="M18 6L6 18M6 6l12 12" />
                        </svg>
                        Clear
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <AnalyticsTab fromDate={fromDate} toDate={toDate} departmentguid={selectedDepartment} />
            </section>
          </div>

          <div className="quick-access-column">
            <section className="quick-access-section">
              <div className="section-header"><h2>Quick Access</h2></div>
              <div className="quick-access-cards">
                {courseCards.map((card) => (
                  <div
                    key={card.id}
                    className={`quick-access-card ${card.status} ${!isReady ? 'card-loading' : ''}`}
                    onClick={isReady ? card.onClick : undefined}
                    style={{ cursor: isReady ? 'pointer' : 'default', pointerEvents: isReady ? 'auto' : 'none' }}
                  >
                    <div className={`status-badge ${card.status}`}>{card.status.charAt(0).toUpperCase() + card.status.slice(1)}</div>
                    <FaEllipsisH className="menu-icon" />
                    <div className="card-content-wrapper">
                      <div className="quick-access-image-container">
                        <img
                          src={card.image}
                          alt={card.title}
                          className="quick-access-image"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            const iconWrapper = document.createElement('div');
                            iconWrapper.className = 'quick-access-icon-wrapper';
                            iconWrapper.innerHTML = card.icon;
                            e.target.parentElement.appendChild(iconWrapper);
                          }}
                        />
                      </div>
                      <div className="card-text-content">
                        <div className="text-content-wrapper">
                          <h3>{card.title}</h3>
                          <p className="quick-access-description">{card.description}</p>
                        </div>
                        <div className="quick-access-footer"><span className="view-details">View Details →</span></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
